<app-user-edit [userID]="userID" [isNew]="isNew" (close)="returnToListPage()"></app-user-edit>